<template>
<!-- 会员管理－单个会员操作记录 -->
    <content-view>
        <div class="wrap-container-in">
            <a-table bordered :dataSource="dataSource" :loading="loading" :columns="columns" :pagination="pagination" @change="changePage" :rowKey="record => record.id">
                <span slot="index" slot-scope="a,b,c">{{c+1}}</span>
                <span slot="grantGoodsCategory" slot-scope="a,row">{{categorys[row.grantGoodsCategory]}}</span>
                <span slot="num" slot-scope="a,row">{{row.type == '1' ? '+' : '-'}}{{row.num}}</span>
            </a-table>
        </div>
    </content-view>
</template>

<script type="text/javascript">
    const columns = [
    {
        title: "序号",
        dataIndex: "index",
        scopedSlots: { customRender: "index" }
    },
    {
        title: "操作时间",
        dataIndex: "operateTime",
        // scopedSlots: { customRender: "createTime" }
    },
    {
        title: "操作动作",
        dataIndex: "grantGoodsCategory",
        scopedSlots: { customRender: "grantGoodsCategory" }
    },
    {
        title: "操作内容",
        dataIndex: "grantName"
    },
    {
        title: "备注类型",
        dataIndex: "remarkCategoryName"
    },
    {
        title: "备注",
        dataIndex: "remark",
    },
    {
        title: "操作人",
        dataIndex: "operator"
    }]
    export default {
        name: "storeDetail",
        components: {},
        props: {},
        data() {
            const categorys = {
                TICKET: "票券",
                COUPON: "优惠券",
                POINT: "积分",
                BALANCE: "储值",
            }
            return {
                loading: false,
                columns,
                categorys,
                dataSource: [],
                pagination: {
                    showTotal: total => `共 ${total} 条数据`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: 0,
                    current: 1,
                    pageSize: 20
                },
            };
        },
        computed: {},
        methods: {
            changePage(page) {
                this.pagination = page;
                this.getList();
            },
            // 获取会员积分详情
            getList() {
                this.loading = true;
                this.$api.member.operateMemberLogList({
                    body: {
                        userId: this.$route.query.id,
                        pageNum: this.pagination.current,
                        pageSize: this.pagination.pageSize
                    }
                }).then(res => {
                    this.loading = false;
                    this.dataSource = res.list;
                    this.pagination.total = res.total;
                }).catch(err => {
                    this.loading = false;
                })
            },
        },
        created() {},
        mounted() {
            this.id = this.$route.query.id
            this.getList()
        }
    };
</script>
<style lang="scss">
</style>